// Some animations
window.addEventListener('DOMContentLoaded', () => document.documentElement.classList.add('js-onload'));
window.addEventListener('beforeunload', () => document.documentElement.classList.add('js-unload'));
window.addEventListener('pageshow', (event) => {
	if (event.persisted) {
		document.documentElement.classList.remove('js-unload');
	}
});
// window.addEventListener('pageshow', (event) => {
// 	if (event.persisted) {
// 		console.log('This page was restored from the bfcache.');
// 	} else {
// 	  console.log('This page was loaded normally.');
// 	}
// });
